export const food = [
  // --- 台灣與亞洲特色 ---
  { char: '🧋', name: 'Bubble Tea', nameZh: '珍珠奶茶', keywords: ['tea', 'taiwan', 'drink'], hot: true },
  { char: '🍜', name: 'Ramen', nameZh: '拉麵', keywords: ['japan', 'soup', 'noodle'], hot: true },
  { char: '🍲', name: 'Hot Pot', nameZh: '火鍋', keywords: ['winter', 'soup', 'chinese'], hot: true },
  { char: '🥟', name: 'Dumpling', nameZh: '水餃/小籠包', keywords: ['dim sum', 'chinese'] },
  { char: '🍱', name: 'Bento', nameZh: '便當', keywords: ['lunch', 'japan'] },
  { char: '🍣', name: 'Sushi', nameZh: '壽司', keywords: ['japan', 'fish'] },
  { char: '🍵', name: 'Matcha', nameZh: '抹茶', keywords: ['green tea', 'japan'] },
  
  // --- 精緻餐飲與甜點 ---
  { char: '🥐', name: 'Croissant', nameZh: '可頌', keywords: ['bread', 'brunch', 'france'], hot: true },
  { char: '🥯', name: 'Bagel', nameZh: '貝果', keywords: ['bread', 'breakfast'] },
  { char: '🥑', name: 'Avocado', nameZh: '酪梨', keywords: ['healthy', 'green', 'salad'], hot: true },
  { char: '🍰', name: 'Cake', nameZh: '切片蛋糕', keywords: ['birthday', 'sweet', 'dessert'] },
  { char: '🍦', name: 'Ice Cream', nameZh: '霜淇淋', keywords: ['dessert', 'sweet', 'summer'] },
  { char: '🍩', name: 'Donut', nameZh: '甜甜圈', keywords: ['snack', 'sweet'] },
  { char: '🥞', name: 'Pancakes', nameZh: '鬆餅', keywords: ['brunch', 'sweet'] },
  { char: '🍓', name: 'Strawberry', nameZh: '草莓', keywords: ['fruit', 'red'] },
  
  // --- 飲品 ---
  { char: '☕', name: 'Coffee', nameZh: '咖啡', keywords: ['caffeine', 'morning', 'latte'], hot: true },
  { char: '🥤', name: 'Soda', nameZh: '手搖飲', keywords: ['drink', 'ice'] },
  { char: '🍷', name: 'Wine', nameZh: '紅酒', keywords: ['fancy', 'dinner', 'alcohol'] },
  { char: '🍺', name: 'Beer', nameZh: '啤酒', keywords: ['party', 'alcohol', 'cheers'] },
  { char: '🍹', name: 'Cocktail', nameZh: '調酒', keywords: ['beach', 'summer', 'night'] },
];